import { useEffect, useState } from "react";
import PediPlayPageHeader from "../Shared/UI/PediplayPageHeader";
import { GetAgeOutReport } from "../Shared/Services";
import ReportTable from "./ReportTable";
import { Button, Col, Row, Select, Tooltip } from "antd";
import { ExportOutlined } from "@ant-design/icons";
import { iconSize } from "../Shared/UI/jsx";
import { exportToCSV } from "../Shared/Functions";
import dayjs from "dayjs";

const AgeOutReports = props => {
    const current = dayjs();
    const [month, setMonth] = useState(current.month() + 1);
    const [year, setYear] = useState(current.year());

    const [loading, setLoading] = useState(true);
    const [data, setData] = useState();
    const [highlighted, setHighlighted] = useState();


    const fetchReport = () => {
        setLoading(true);
        GetAgeOutReport(month, year)
            .then((res) => {
                setData(res.data);
                setHighlighted(res.data[0]);
            })
            .finally(() => {
                setLoading(false);
            })
    };

    useEffect(() => {
        fetchReport();
    }, [month, year]);

    const handleRowOnClick = record => {
        setHighlighted(record);
    }


    const extra = (
        <div style={{ textAlign: 'end' }}>
            <Tooltip title="Export" placement="top">
                <Button
                    type="link"
                    icon={<ExportOutlined style={iconSize} />}
                    onClick={() => exportToCSV("AgeOutReports.csv", data)}
                />    
            </Tooltip>
        </div>
    );

    const monthOptions = Array.from({ length: 12 }, (_, i) => ({
        label: dayjs().month(i).format("MMMM"),
        value: i + 1,
    }));

    const yearOptions = Array.from({ length: 11 }, (_, i) => {
        const y = current.year() - 5 + i;
        return { label: y, value: y };
    });
    
    return (
        <div>
            <Row gutter={[8,8]}>
                <Col span={24}>
                    <PediPlayPageHeader
                        title={'Age Out Reports'}
                        props={props}
                        loading={loading}
                        extra={extra}
                    />
                </Col>
                <Col span={24}>
                    <Row gutter={12}>
                        <Col>
                            <Select
                                value={month}
                                onChange={setMonth}
                                options={monthOptions}
                                style={{ width: 160 }}
                            />    
                        </Col>
                        <Col>
                            <Select
                                value={year}
                                onChange={setYear}
                                options={yearOptions}
                                style={{ width: 120 }}
                            />    
                        </Col>                        
                    </Row>
                </Col>
                <Col span={24}>
                    <ReportTable reports={data} loading={loading} highlighted={highlighted} handleRowOnClick={handleRowOnClick} />
                </Col>
            </Row>
        </div>
    );
}

export default AgeOutReports;